import type { SVGProps } from 'react';

const SvgPointLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M9.99 17.98C14.4028 17.98 17.98 14.4028 17.98 9.99C17.98 5.57724 14.4028 2 9.99 2C5.57724 2 2 5.57724 2 9.99C2 14.4028 5.57724 17.98 9.99 17.98Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.9805 19.88C13.8805 21.15 15.3505 21.98 17.0305 21.98C19.7605 21.98 21.9805 19.76 21.9805 17.03C21.9805 15.37 21.1605 13.9 19.9105 13'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 15V11.2105M8 11.2105V7H11.1999C11.8062 7 12.3831 7.26138 12.7828 7.71721C13.4793 8.51151 13.4793 9.69902 12.7828 10.4933C12.3831 10.9491 11.8062 11.2105 11.1999 11.2105H8Z'
      stroke='currentColor'
    />
  </svg>
);
export default SvgPointLt;
